export const KEY_SEARCH_MORE = [
  'area',
  'email',
  'method',
  'originalUrl',
  'startDate',
  'endDate',
];

export const CONDITIONS = [
  {
    value: 'and',
    label: 'AND',
  },
  {
    value: 'or',
    label: 'OR',
  },
];

export const OPERATORS = [
  {
    value: 'is',
    label: 'is',
  },
  {
    value: 'ne',
    label: 'is not',
  },
];

export const OPERATORS_WITH_CONST = [
  {
    value: 'contL',
    label: 'is',
  },
  {
    value: 'ne',
    label: 'is not',
  },
];

export const ORDER_FILTERS = [
  {
    text: 'orders.filters.all',
    value: 'all',
  },
  {
    text: 'orders.filters.pending',
    value: 'pending',
  },
  {
    text: 'orders.filters.confirmed',
    value: 'approved',
  },
  {
    text: 'orders.filters.inProgress',
    value: 'in_progress',
  },
  {
    text: 'orders.filters.delivering',
    value: 'in_shipment',
  },
  {
    text: 'orders.filters.completed',
    value: 'completed',
  },
  {
    text: 'orders.filters.cancelled',
    value: 'cancelled',
  },
];

export const REVIEW_PRODUCT_FILTERS = [
  {
    text: 'reviewProducts.filters.all',
    value: 'all',
  },
  {
    text: 'reviewProducts.filters.order',
    value: 'order',
  },
  {
    text: 'reviewProducts.filters.product',
    value: 'product',
  },
];

export const ORDER_RETURN_FILTERS = [
  {
    text: 'orders.filters.all',
    value: 'all',
  },
  {
    text: 'returnOrders.filters.pending',
    value: 'PENDING',
  },
  {
    text: 'returnOrders.filters.inProgress',
    value: 'IN_PROGRESS',
  },
  {
    text: 'returnOrders.filters.notPassQc',
    value: 'NOT_PASS_QC',
  },
  {
    text: 'returnOrders.filters.completed',
    value: 'COMPLETED',
  },
  {
    text: 'returnOrders.filters.cancelled',
    value: 'CANCELLED',
  },
];

export const CMS_BANNER_TYPES = [
  {
    text: 'cms.filters.homeBanner',
    value: 'homeBanner',
  },
  {
    text: 'cms.filters.listingBanner',
    value: 'listingBanner',
  },
  {
    text: 'cms.filters.productsBanner',
    value: 'productsBanner',
  },
  {
    text: 'cms.filters.productDetailBanner',
    value: 'productDetailBanner',
    isShowAllPage: true,
  },
  {
    text: 'cms.filters.popupTopBanner',
    value: 'popupTopBanner',
    isShowAllPage: true,
  },
  {
    text: 'cms.filters.popupBottomBanner',
    value: 'popupBottomBanner',
    isShowAllPage: true,
  },
  {
    text: 'cms.filters.popupCenterBanner',
    value: 'popupCenterBanner',
    isShowAllPage: true,
  },
  {
    text: 'cms.filters.floatButton',
    value: 'floatButton',
    isShowAllPage: true,
  },
];

export const CMS_STATUS = [
  {
    text: 'common.status.pending',
    value: 'pending',
  },
  {
    text: 'common.status.active',
    value: 'active',
  },
  {
    text: 'common.status.draft',
    value: 'draft',
  },
];

export const BANNER_POSITIONS = [
  {
    text: 'cms.positions.left',
    value: 'left',
  },
  {
    text: 'cms.positions.center',
    value: 'center',
  },
  {
    text: 'cms.positions.right',
    value: 'right',
  },
  {
    text: 'cms.positions.bottomLeft',
    value: 'bottomLeft',
  },
  {
    text: 'cms.positions.bottomCenter',
    value: 'bottomCenter',
  },
  {
    text: 'cms.positions.bottomRight',
    value: 'bottomRight',
  },
];

export const BUTTON_TYPES = [
  {
    text: 'common.buttonType.border',
    value: 'border',
  },
  {
    text: 'common.buttonType.solid',
    value: 'solid',
  },
];

export const MISCELLANEOUS_TYPES = [
  {
    text: 'miscellaneous.termsConditions',
    value: '/miscellaneous/terms-conditions',
  },
  {
    text: 'miscellaneous.privacyPolicy',
    value: '/miscellaneous/privacy-policy',
  },
  {
    text: 'miscellaneous.refundPolicy',
    value: '/miscellaneous/refund-policy',
  },
  // {
  //   text: 'miscellaneous.contactUs',
  //   value: '/miscellaneous/contact-us',
  // },
];
export const ORDER_TABS_STATUS = [
  {
    text: 'orders.filters.all',
    value: 'all',
  },
  {
    text: 'orders.filters.awaitingConfirmation',
    value: 'AWAITING_CONFIRMATION',
  },
  {
    text: 'orders.filters.approved',
    value: 'APPROVED',
  },
  {
    text: 'orders.filters.processing',
    value: 'PROCESSING',
  },
  {
    text: 'orders.filters.delivering',
    value: 'DELIVERING',
  },
  {
    text: 'orders.filters.deliverySuccess',
    value: 'DELIVERY_SUCCESS',
  },
  {
    text: 'orders.filters.cancelled',
    value: 'CANCELLED',
  },
];
